import { gql } from '@apollo/client'
import { FormModelFragment } from '../fragments/form-model.fragment'

export const FORM_MODELS = gql`
  query formModels($projectId: ID!) {
    formModels(projectId: $projectId) {
      ...FormModelFragment
    }
  }
  ${FormModelFragment}
`

export const AVAILABLE_FORM_MODELS = gql`
  query availableFormModels($projectId: ID!) {
    availableFormModels(projectId: $projectId) {
      ...FormModelFragment
    }
  }
  ${FormModelFragment}
`

export const FORM_MODEL = gql`
  query formModel($id: ID!) {
    formModel(id: $id) {
      ...FormModelFragment
    }
  }
  ${FormModelFragment}
`
